import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../hooks'
import { ConfirmationModal } from '../../../Confirmation'
import { useAsyncTable } from '../../../Table'
import {
  getResultTableApiUrls,
  resendDocFlowResultEpost,
} from '../../DocFlowResult'
import { getDocFlowSendingEpostServerErrors } from '../../DocFlowSending'
import { useDocFlowContext } from '../useDocFlowContext'

export function useResultPhase() {
  const { t } = useTranslation()

  const { documentId, handleCloseModal, setModal } = useDocFlowContext()

  const [isPageLoader, setPageLoader] = useState(false)

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const tableData = useAsyncTable({
    ...getResultTableApiUrls(documentId),
    withoutSubMenu: true,
  })

  const { handleLoadInit, handleReload } = tableData

  useEffect(() => {
    handleLoadInit()
  }, [])

  function handleReloadTableAfterEpostResend() {
    handleReload()
      .then(() => {
        handleAddSuccessNotification(
          'DocFlow.ResendSuccessNotificationTitleKey'
        )
      })
      .finally(() => {
        setPageLoader(false)
      })
  }

  function getHandleResendEpost(itemId) {
    return () => {
      setPageLoader(true)

      resendDocFlowResultEpost(documentId, itemId)
        .then(handleReloadTableAfterEpostResend)
        .catch(error => {
          handleAddErrorNotification(getDocFlowSendingEpostServerErrors(error))

          setPageLoader(false)
        })
        .finally(() => {
          handleCloseModal()
        })
    }
  }

  function handleClickResendEpost(itemId) {
    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitText: t('Modal.DocFlowConfirmResendEpostBtnKey'),
        }}
        description={t('DocFlow.ConfirmModalResendEpostTextKey')}
        loading={false}
        onCancel={handleCloseModal}
        onSubmit={getHandleResendEpost(itemId)}
      />
    )
  }

  return {
    handleClickResendEpost,
    isPageLoader,
    tableData,
  }
}
